import React, { useEffect, useState} from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from "react-router-dom";
import axios from "axios";
import "./App.css";

const api_key = "8b62f4bda40c67dbe48ddb6db1f858dc";
const BASE_URL = "https://api.themoviedb.org/3";
const getImage = (path) => `https://image.tmdb.org/t/p/w300/${path}`;
const getLink = (path) => `https://fsapi.xyz/tmdb-movie/${path}`;
function Animation() {
    const [data, setData] = useState([]);
    const [pg, setValue] = useState(1);
    const  handleClick = (e) => setValue(e.target.value++);
    const  handleClickdc = (e) => setValue(e.target.value--);
    const api = axios.create({ baseURL: BASE_URL });

    const getTrending = api.get("trending/all/day", { params: { api_key } });
    
    const getG =  api.get(`discover/movie?api_key=${api_key}&with_genres=16&page=${pg}`);
    useEffect(() => {
      getG.then((res) => {
        setData(res.data.results);
      });
    }, [pg]);
    
    return (
     
        <div>
         <Router>
      <Switch>
    
      
            </Switch>
      </Router>
 
                <div className="App">
                <div className="cd">  <button  value={pg} className="btn"
            onClick={ handleClickdc } >PREVIOUS</button>        pg:{pg}
<button  value={pg} className="btn"
            onClick={ handleClick} >NEXT</button></div>
      <header className="App-header">
    
        <div className="grid">
          
          {data.map((movie) => (
            <div className="item">
               
             
               <Link to={`/movie/${movie.id}`} className="current">  <img src={getImage(movie.poster_path)} /><p>{movie.original_title}</p></Link>

            </div>
          ))}
        </div>
   
      </header>
    </div>
    
        </div>
    )
}

export default Animation;
